export enum PlatformSharedEntities {
    Address = 'Address',
    AssociatedAddress = 'AssociatedAddress',
    GeoPoint = 'GeoPoint',
    ResourceAuth = 'ResourceAuth',
    CustomField = 'CustomField',
    Formula = 'Formula',
}
